import React, { useMemo } from 'react';
import { usePlanningBottomupState } from '../Context';
import { shortenStringWithTooltip } from '../../../Components/helper';

export function BasicInfoTable() {
  const { planningBottomup, checkVisibleBottomUp, tableHeadArray, lengthEnabled } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel } = planningBottomup;
  const level = selectedLevel?.level;
  const currLevel = selectedLevel?.level || 1;
  const setHeaderFn = () => {
    return tableHeadArray
      .map((tabledata) => {
        if (tabledata.existlevel <= currLevel) {
          tabledata.display = true;
        }
        return tabledata;
      })
      .sort((a, b) => a.sequence - b.sequence);
  };
  const renderHeader = useMemo(() => {
    return setHeaderFn();
  }, [planningBottomup?.changed]);

  const getBodyName = (key, product) => {
    if (key === 'rrp') {
      return product.rrpValue?.value || 0;
    }
    if (key === 'moq' || key === 'mcq') {
      return '1';
    }

    const { basicInfo } = product;
    const { productIndentifier, color, size, length } = basicInfo;
    let suffixFound;
    if (level === 6) {
      suffixFound = productIndentifier?.find((suff) => suff.colorWay === color?._id);
    } else if (level === 7) {
      suffixFound = productIndentifier?.find((suff) => suff.colorWay === color?._id && suff.size === size);
    } else {
      suffixFound = productIndentifier?.find((suff) => suff?.colorWay === color?._id && suff?.size === size && suff?.length === length?._id);
    }
    if (suffixFound) {
      return suffixFound[key];
    }
    return '--';
  };

  const getSubKeyName = (key, subKey, product) => {
    if (subKey === 'references') {
      if (product?.basicInfo[key]) {
        if (product?.basicInfo[key][subKey]) {
          return product?.basicInfo[key][subKey].join(',') || '--';
        }
      }
    }
    if (product.basicInfo[key]) {
      return product.basicInfo[key][subKey] || '--';
    }
    return '--';
  };

  const secondHalfCondition = (head, product) => {
    return head?.subKey ? getSubKeyName(head.key, head.subKey, product) : shortenStringWithTooltip(product?.basicInfo[head?.key], 30) || '--';
  };

  const getCondBodyName = (head, product) => {
    return ['suffix', 'SKU'].includes(head?.key) ? getBodyName(head?.key, product) : secondHalfCondition(head, product);
  };
  return (
    <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
      <thead>
        <tr>
          {renderHeader.map((head, ind) => {
            const isVisible = checkVisibleBottomUp(head?.key);
            if (!lengthEnabled && head?.label === 'Length') return null;
            return (
              head.display &&
              (head.keyName === 'number' ||
              head.label === 'Category 1' ||
              head.label === 'Category 2' ||
              head.label === 'Category 3' ||
              head.label === 'Category 4' ? (
                <th key={ind} className="w-150px">
                  <span title={head.label}>{head.label}</span>
                </th>
              ) : (
                isVisible && (
                  <th key={ind} className="w-150px">
                    <span title={head.label}>{head.label}</span>
                  </th>
                )
              ))
            );
          })}
        </tr>
      </thead>
      <tbody>
        {planningBottomProducts?.map((product, idx) => (
          <tr key={idx}>
            {renderHeader.map((head, ind) => {
              const isVisible = checkVisibleBottomUp(head?.key);
              if (!lengthEnabled && head?.label === 'Length') return null;
              return (
                head.display &&
                (head.keyName === 'number' ||
                head.label === 'Category 1' ||
                head.label === 'Category 2' ||
                head.label === 'Category 3' ||
                head.label === 'Category 4' ? (
                  <td key={ind} className="text-center">
                    {getCondBodyName(head, product)}
                  </td>
                ) : (
                  isVisible && (
                    <td key={ind} className="text-center">
                      {['suffix', 'SKU', 'rrp'].includes(head?.key) ? getBodyName(head?.key, product) : secondHalfCondition(head, product)}
                    </td>
                  )
                ))
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default BasicInfoTable;
